/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    events: [],
    isLoading: false,
    canCreateTestEvents: false,
};
export const EventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        setEvents: (state, action) => {
            state.events = action.payload;
        },
        setEventsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setCanCreateTestEvents: (state, action) => {
            state.canCreateTestEvents = action.payload;
        },
    },
});
export const { setEvents, setEventsLoading, setCanCreateTestEvents } = EventsSlice.actions;
export const selectEvents = (state) => state.events.events;
export const selectIsLoadingEvents = (state) => state.events.isLoading;
export const selectCanCreateTestEvents = (state) => state.events.canCreateTestEvents;
export default EventsSlice.reducer;
